/*
  Итоги страницы «Как сформировался долг»: период и четыре графы отчёта 1С.

  Порядок - тот же, что в отчёте «по начислениям и долгам»: на начало, начислено,
  оплачено, на конец. Юрист сверяет их с отчётом глазами, и переставленные
  графы читались бы как другие цифры.

  Сальдо названо датами, когда даты пришли с загрузкой отчёта: число без даты
  приложить не к чему. У обычной выгрузки начислений сальдо нет вовсе, и тогда
  подпись говорит об этом, а не придумывает дату.
*/

import { Link } from 'react-router-dom'

import { date, monthTitle, money, plural } from '../api/format.js'
import InfoHint from './InfoHint.jsx'

const OPENING_HINT =
  'Сальдо на начало сложено по месяцам и услугам из отчёта 1С. Месяцы, где ' +
  'перерасчёт обнулил начисление или осталась только переплата, в расчёт не ' +
  'загружаются: долга по ним нет. Поэтому сумма здесь может отличаться от ' +
  'отчёта на эти месяцы - обычно на копейки.'

const monthOf = (period) => monthTitle(String(period).slice(0, 7))

export default function DebtTotals({ formation }) {
  const { total, period } = formation

  return (
    <section className="debt-totals">
      <div className="debt-totals__item debt-totals__item--wide">
        <div className="summary__cap">Период долга</div>
        <div className="debt-totals__text">
          {period ? `${monthOf(period.since)} - ${monthOf(period.until)}` : 'долга нет'}
        </div>
        {period ? (
          <div className="debt-totals__note">
            {plural(period.months, 'месяц', 'месяца', 'месяцев')} с непогашенным долгом
          </div>
        ) : null}
      </div>

      <div className="debt-totals__item">
        <div className="summary__cap">
          Сальдо на начало
          <InfoHint title="Откуда цифра" text={OPENING_HINT} />
        </div>
        <div className="debt-totals__value">{money(total.opening)}</div>
        <div className="debt-totals__note">
          {formation.balance_since ? `на ${date(formation.balance_since)}` : 'в выгрузке сальдо не было'}
        </div>
      </div>

      <div className="debt-totals__item">
        <div className="summary__cap">Начислено</div>
        <div className="debt-totals__value">
          {Number(total.accrued) ? '+ ' : ''}
          {money(total.accrued)}
        </div>
        <div className="debt-totals__note">корректировка {money(total.adjustment)}</div>
      </div>

      <div className="debt-totals__item">
        <div className="summary__cap">Оплачено</div>
        <div className="debt-totals__value">
          {Number(total.paid) ? '- ' : ''}
          {money(total.paid)}
        </div>
        {/* Платёж выписки или обмена, не отнесённый к месяцу, в «Оплачено» не входит - система
            не разносит его сама (допущение юриста). Деньги при этом названы, а не потеряны
            из виду: вкладка «Оплаты» показывает ту же сумму (аудит 26.10.2026, расхождение 2). */}
        {Number(formation.unapplied_payments) > 0 ? (
          <div className="debt-totals__note">
            ещё поступило {money(formation.unapplied_payments)}: не отнесено к месяцу, в оплаченное
            не входит. <Link to={`/accounts/${formation.account_id}?tab=payments`}>Вкладка «Оплаты»</Link>
          </div>
        ) : null}
      </div>

      <div className="debt-totals__item debt-totals__item--result">
        <div className="summary__cap">Сальдо на конец</div>
        <div className="debt-totals__value">{money(total.closing)}</div>
        <div className="debt-totals__note">
          {formation.balance_as_of ? `на ${date(formation.balance_as_of)}` : 'по загруженным начислениям'}
        </div>
      </div>
    </section>
  )
}
